const adv_times_list = [
  { key: 1, value: 1, text: "1 tydzień" },
  { key: 2, value: 2, text: "2 tygodnie" },
  { key: 3, value: 3, text: "3 tygodnie" },
  { key: 4, value: 4, text: "4 tygodnie" }
];

export default  adv_times_list; 

//   { key: "...", value: "-1" },